/* eslint-disable import/no-webpack-loader-syntax */ import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import radiantOrangeUrl from '../../../assets/gems/radiant_orange.svg?inline';
export function RadiantOrange({ ...props }) {
    return /*#__PURE__*/ _jsx("img", {
        ...props,
        src: radiantOrangeUrl,
        alt: "RadiantOrangeImage"
    });
}
